const EXTENSION_PATTERN = /\.[^.]+$/;

export const fileNameWithoutExtension = (filename: string): string =>
	filename.replace(EXTENSION_PATTERN, "");
